<template>
  <div class="container">
    <b-sidebar type="is-light"
               :fullheight="false"
               :fullwidth="false"
               :overlay="false"
               :right="false"
               v-model="open">
      <div class="p-1 has-text-centered">
        <a :href="$CCURL">Carbon Calculator</a>
        <br />
        <a href="/login">CTC Compliance Index</a>
      </div>
    </b-sidebar>
    <div class="level">
      <div class="level-left">
        <b-button icon-right="bars" @click="open = !open"></b-button>
      </div>
      <div class="level-item">
        <figure class="image is-flex" style="justify-content: center">
          <img class="banner-icon" style="max-width: 500px;" src="@/assets/images/awg-logo-2-10-2020.png" />
        </figure>
      </div>
    </div>

    <div class="container margin-top">
      <userNavbar></userNavbar>
    </div>
  </div>
</template>

<script>
  import userNavbar from "@/components/navigation/userNav.vue";
  export default {
    components: {
      userNavbar
    },
    data() {
      return {
        open: false
      }
    }
  }
</script>
